<template lang="html">

  <section class="fundraising">
    <div class="pageHeading">
      <h1>Apply Fundraising</h1>
    </div>
<add-fundraising v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"></add-fundraising>


  </section>

</template>

<script lang="js">
    import addFundraising from '../components/AddFundraising'
  export default  {
    name: 'payments',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
      components: {
          addFundraising
      },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">

</style>
